import { Navigate, Outlet } from "react-router-dom";
import { authenticationService } from "@/services/api_functions";
import withRouter from "./withRouter";
const PrivateRoutes = (props) => {
  console.log("private props", props);
  const currentUser = authenticationService.currentUserValue;
  console.log("PrivateRoutes user -> ", currentUser);
  return currentUser && currentUser != "" ? (
    <Outlet {...props} />
  ) : (
    <Navigate to="/" replace={true} />
  );
};

export default withRouter(PrivateRoutes);
